// -----------------------------------
// ---------- Public Layout ----------
// -----------------------------------
import publicLayout from '../pages/public';
import ChangeInfo from '../pages/public/ChangeInfo.vue';
import Notifs from '../pages/public/Notifications.vue';
// khanesh
import Post from '../pages/public/khanesh/Post.vue';
import Khanesh from '../pages/public/khanesh/Khanesh.vue';
// barjestegi
import Barjestegi from '../pages/public/barjestegi/Barjestegi.vue';
import CourseDetails from '../pages/public/barjestegi/CourseDetails.vue';
// moshavere
import Advisor from '../pages/public/advicor/Advisor.vue';
import MyAdvisor from '../pages/public/advicor/MyAdvisor.vue';
import MyAdvices from '../pages/public/advicor/MyAdvices.vue';
import MyRequests from '../pages/public/advicor/MyRequests.vue';
// resaneh
import resanehLayout from '../pages/public/resaneh/';
import Video from '../pages/public/resaneh/Video.vue';
import Podcast from '../pages/public/resaneh/Podcast.vue';
import Webinar from '../pages/public/resaneh/Webinar.vue';
import BookMarks from '../pages/public/resaneh/BookMarks.vue';

import resanehDetailsLayout from '../pages/public/resaneh/details';
import PodcastDetails from '../pages/public/resaneh/PodcastDetails.vue';
import VideoDetails from '../pages/public/resaneh/VideoDetails.vue';

// -----------------------------------
// ---------- Course Layout ----------
// -----------------------------------
import coursesLayout from '../pages/courses/';
import BaseCourse from '../pages/courses/BaseCourse.vue';
import BaseCourseDetails from '../pages/courses/BaseCourseDetails.vue';
import MyCourses from '../pages/courses/MyCourses.vue';
import MyWealth from '../pages/public/finance/MyWealth.vue';
import Activate from '../pages/public/finance/Activate.vue';
import PaymentStatus from '../pages/public/finance/PaymentStatus.vue';

// -----------------------------------
// ----------- Auth Layout -----------
// -----------------------------------
import authLayout from '../pages/auth/';
import Login from '../pages/auth/Login.vue';
import Register from '../pages/auth/Register.vue';
import PreRegister from '../pages/auth/PreRegister.vue';

export default [
    // Public Layout
    {
        path: '/',
        component: publicLayout,
        meta: {
            // checkAuth: true
        },
        children: [
            {
                path: '',
                name: 'Khanesh',
                component: Khanesh,
            },
            {
                path: 'resaneh',
                component: resanehLayout,
                children: [
                    {
                        path: '',
                        redirect: { name: 'Webinar' }
                    },
                    {
                        path: 'video',
                        name: 'Video',
                        component: Video,
                    },
                    {
                        path: 'podcast',
                        name: 'Podcast',
                        component: Podcast,
                    },
                    {
                        path: 'webinar',
                        name: 'Webinar',
                        component: Webinar,
                    },
                    {
                        path: 'bookmarks',
                        name: 'BookMarks',
                        component: BookMarks
                    }
                ]
            },
            {
                path: 'khanesh/:id',
                name: 'Post',
                component: Post,
            },
            {
                path: 'barjestegi',
                name: 'Barjestegi',
                component: Barjestegi,
            },
            {
                path: 'barjestegi/:id',
                name: 'CourseDetails',
                component: CourseDetails,
            },
            {
                path: 'advisor',
                name: 'Advisor',
                component: Advisor,
            },
            {
                path: 'change-info',
                name: 'ChangeInfo',
                component: ChangeInfo,
            },
            {
                path: 'notifs',
                name: 'Notifications',
                component: Notifs,
            },
            {
                path: 'payment-status',
                name: 'PaymentStatus',
                component: PaymentStatus,
            },
            {
                path: 'my-advisor',
                name: 'MyAdvisor',
                component: MyAdvisor,
            },
            {
                path: 'my-advices',
                name: 'MyAdvices',
                component: MyAdvices,
            },
            {
                path: 'my-requests',
                name: 'MyRequests',
                component: MyRequests,
            }
        ]
    },
    {
        path: '/resaneh',
        meta: {
            // checkAuth: true
        },
        component: resanehDetailsLayout,
        children: [
            {
                path: 'podcast/:id',
                name: 'PodcastDetails',
                component: PodcastDetails
            },
        ]
    },
    // Course Layout
    {
        path: '/resaneh',
        meta: {
            // checkAuth: true
        },
        component: coursesLayout,
        children: [
            {
                path: 'video/:id',
                name: 'VideoDetails',
                component: VideoDetails,
            }
        ]
    },

    // Course Layout
    {
        path: '/course',
        component: coursesLayout,
        meta: {
            // checkAuth: true
        },
        children: [
            {
                path: 'base-course/:course',
                name: 'BaseCourse',
                component: BaseCourse,
                meta: {
                    title: 'دوره پایه',
                }
            },
            {
                path: 'base-course/:course/:id',
                name: 'BaseCourseDetails',
                component: BaseCourseDetails,
                meta: {
                    title: 'محتوای ویدیو',
                }
            },
            {
                path: 'mine',
                name: 'MyCourses',
                component: MyCourses,
                meta: {
                    title: 'دوره‌های من',
                }
            }
        ]
    },
    {
        path: '/',
        component: coursesLayout,
        meta: {
            // checkAuth: true
        },
        children: [
            {
                path: 'my-wealth',
                name: 'MyWealth',
                component: MyWealth,
                meta: {
                    title: 'سرمایه من',
                }
            },
            {
                path: 'activate-card/:id',
                name: 'ActivateCard',
                component: Activate,
                meta: {
                    title: 'فعال سازی کارت',
                }
            },
            {
                path: 'activate-gift/:id',
                name: 'ActivateGift',
                component: Activate,
                meta: {
                    title: 'فعال سازی هدیه',
                }
            }
        ]
    },

    // Auth Layout
    {
        path: '/',
        component: authLayout,
        meta: {
            checkAuth: true
        },
        children: [
            {
                path: 'register/:number/:id',
                name: 'Register',
                component: Register,
                meta: {
                    title: 'Register',
                }
            },
            {
                path: '/login',
                name: 'Login',
                component: Login,
                meta: {
                    title: 'Login',
                }
            },
            {
                path: '/pre-register',
                name: 'PreRegister',
                component: PreRegister,
                meta: {
                    title: 'پیش ثبت نام',
                }
            }
        ]
    },

    // Other
    {
        path: '*',
        name: 'not-found',
        component: () => import('../pages/errors/404.vue'),
        meta: {
            title: '404'
        }
    }
];
